export default "__VITE_ASSET__bb9a9a91__"